import React, {useEffect} from 'react';
import {useParams} from "react-router-dom";
import {removeAuthRef, setAuthRef} from "../Auth/services/authRefService";
import {getAccessToken} from "../Auth/services/tokenService";
import {useGetCurrentUser, useGetOrganisations} from "../Auth/api/auth";
import {useNavigateTo} from "../../core/hooks/useNavigate";
import {useGetSharedModule} from "./api/shared";
import {setActiveOrganisation} from "../Auth/services/organisationService";
import {toast} from "react-toastify";
import {FullLoading} from "../../core/components/loading";

function SharedScreen(props) {
    const {module , uuid} = useParams();
    const token = getAccessToken()
    const navigateTo = useNavigateTo()
    const pathName = window.location.pathname;

    useEffect(() => {
        setAuthRef(pathName);
    }, [pathName]);

    const {
        data: userData,
        error: userError,
        isLoading: userLoading,
        isSuccess: userSuccess,
        isError: userIsError,
    } = useGetCurrentUser({
        enabled: !!token,
    })
    const {
        data: organisationData,
        error: organisationError,
        isLoading: organisationLoading,
        isSuccess: organisationSuccess,
        isError: organisationIsError,
    } = useGetOrganisations({
        enabled: !!userData,
    })

    const {
        data: moduleData,
        isSuccess: moduleSuccess,
        isError: moduleError,
    } = useGetSharedModule(
        module,
        uuid,
        {
            enabled: !!userData,
        }
    )

    useEffect(() => {
        let organization = {}
        if (organisationSuccess && moduleSuccess)
        {
            organization = organisationData?.data?.find(item =>
                item.status === "accepted" &&
                item.organizationId === moduleData?.data?.organizationId
            );

            if (organization) {
                setActiveOrganisation(organization);
                removeAuthRef();
                navigateTo(`/app/${module}/${moduleData.data.id}`);
            }
        }
        if (!organization || organisationIsError || moduleError){
            removeAuthRef();
            toast.error('دسترسی به این محتوا فقط برای اعضای تأییدشده کانون امکان‌پذیر است.')
            navigateTo('/app');
        }
    }, [organisationData, moduleData, organisationIsError, moduleError]);

    useEffect(() => {
        if (!token) {
            navigateTo(`/authenticate/login`)
        }
    }, [])
    return (
        <FullLoading message={'در حال انتقال به صفحه مورد نظر...'} />
    );
}

export default SharedScreen;